"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
exports.default = (function (transparent48) { return function (data) {
    return [0x48, 5, 11, 0].map(function (val) { return utils_1.decToHex(val); });
}; });



// WEBPACK FOOTER //
// ./src/transparent48/encode/11.ts